class CompareSlider extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('.compare-wrapper');
    this.range = this.querySelector('.compare-range');
    this.animationFrame = null;

    this.onInput = this.onInput.bind(this);
    this.updatePosition = this.updatePosition.bind(this);
  }

  connectedCallback() {
    this.range.addEventListener('input', this.onInput);
    // Initial update
    this.updatePosition(this.range.value);
  }

  disconnectedCallback() {
    this.range.removeEventListener('input', this.onInput);
  }

  onInput(e) {
    if (this.animationFrame) cancelAnimationFrame(this.animationFrame);

    this.animationFrame = requestAnimationFrame(() => {
      this.updatePosition(e.target.value);
    });
  }

  updatePosition(value) {
    this.wrapper.style.setProperty('--position', `${value}%`);
  }
}

customElements.define('compare-slider', CompareSlider);
